import { createAsyncThunk } from '@reduxjs/toolkit';
import { projectSubmitApi } from 'container/projectSubmitApi';
import { serializeError } from 'shared/utils/redux';

import { STORE_NAME } from './initialState';

export const fetchProjectSubmits = createAsyncThunk(
  `${STORE_NAME}/fetchProjectSubmits`,
  async ({ projectId }: { projectId: number }) => {
    return projectSubmitApi.list(projectId);
  },
  { serializeError },
);
